import type { SelectedClient } from '@/entities/client';
import { useSheetStore } from '@/shared/stores/sheet-store';

// A plain function rather than a hook so the chart's Contacts section can call it from a click
// handler — see `open-edit-client-profile-sheet.ts` for the same shape.
export function openAddClientContactSheet(client: SelectedClient) {
    useSheetStore.getState().openSheet({
        type: 'clients/add-contact',
        label: 'Add contact',
        data: { id: client.id, name: client.name, openingId: crypto.randomUUID() },
    });
}
